import BulkMessaging from './BulkMessaging';

export default BulkMessaging;
